<template>
    <!--醫院 科別 簡介-->
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md6 style="text-align: center">
                        <v-flex xs12 sm12 md12 d-inline-flex>
                            <v-flex xs2 sm2 md2 text-right  class="labelFont">
                                <v-label >影像</v-label>
                            </v-flex>
                            <v-flex xs10 sm10 md10 pl-2>

                                <img   :src="docImage" id="image1" :class="[ docImage!='' ? 'uerIcon' : 'noUerIcon']" ref="imgref" style=" border: 1px solid gray;min-width: 200px;
    max-width: 200px;">

                                <!-- pickPicPhoto('iptImage1','image1',25,25)-->
                                <input  class="custom-file-input" type="file" ref="fileref"  id="iptImage1" value="" @change="pickImage"  />

                                <v-btn  title="刪除影像" icon  @click.native.stop="deleteImgIcon"><!---->
                                    <v-icon  color="pink">mdi-delete</v-icon>
                                </v-btn>

                            </v-flex>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md6>
                        <v-flex row wrap xs12 sm12 md12 >
                            <v-flex xs3 sm3 md6 text-right  class="labelFont">
                                <v-label >簡介類別</v-label>
                            </v-flex>
                            <v-flex xs9 sm9 md6 pl-2>
                                <v-autocomplete
                                        :disabled="this.editIndex!=-1"
                                        v-model="docType"
                                        hide-details
                                        :items="docList"
                                        item-text="value"
                                        item-value="key"
                                ></v-autocomplete>
                            </v-flex>
                        </v-flex>

                        <v-flex row wrap xs12 sm12 md12>
                            <v-flex xs3 sm3 md6 text-right  class="labelFont">
                                <v-label >科別代號</v-label>
                            </v-flex>
                            <v-flex xs9 sm9 md6 pl-2>
                                <v-text-field :disabled="this.editIndex!=-1"  v-model="docCode"   clearable></v-text-field>
                            </v-flex>
                        </v-flex>


                        <v-flex row wrap xs12 sm12 md12>
                            <v-flex xs3 sm3 md6 text-right  class="labelFont">
                                <v-label >院區代號</v-label>
                            </v-flex>
                            <v-flex xs9 sm9 md6 pl-2>
                                <v-select
                                        v-if="this.zoneNameList.length>0"
                                        :disabled="this.editIndex!=-1"
                                        v-model="zone"
                                        hide-details
                                        :items="zoneNameList"
                                        :item-text="zoneItemText"
                                        item-value="zone"
                                ></v-select>
                                <v-text-field v-else   :disabled="this.editIndex!=-1"  v-model="zone"   clearable></v-text-field>
                            </v-flex>
                        </v-flex>

                    </v-flex>



                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm3 md3 text-right  class="labelFont">
                            <v-label >醫院(科別)說明</v-label>
                        </v-flex>
                        <v-flex xs7 sm9 md9 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="hospDoc"  v-model="hospDoc"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>

                    <!--<v-flex xs12 sm12 md12 d-inline-flex>-->
                        <!--<v-card-text>-->
                               <!--<pre style="width: auto;background: white;margin-top: 10px;height: auto;">-->
                         <!--<code id="ORIJsonCode" style="font-size: 1rem;color: black;font-weight: normal"></code>-->
                        <!--</pre>-->
                        <!--</v-card-text>-->

                    <!--</v-flex>-->





                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-card>
</template>

<script>
    export default {
        name: "EditHsopDoc",
        props:['editIndex','isShow','editObj','zoneNameList'],
        data() {
            return {
                docList:[
                    {key:'HOSP',value:'HOSP-醫院'},
                    {key:'DIV',value:'DIV-科別'},
                    {key:'SELFDIV',value:'SELFDIV-自定義科別'},
                ],
                docType:'',//簡介類別
                docCode:'',//科別代號/院區代號
                docImage:'',//影像
                zone:'',//院區代號
                hospDoc:'',//醫院說明/科別說明
                snTimeout:4000,
                snStatus:false,
                snText:'',
                modifyObj:{},
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.docType = this.editObj.docType==undefined?'':this.editObj.docType;
                    this.docCode = this.editObj.docCode==undefined?'':this.editObj.docCode;
                    this.zone = this.editObj.zone==undefined?'':this.editObj.zone;
                    this.docImage = this.editObj.docImage==undefined?'':this.editObj.docImage;
                    this.hospDoc = this.editObj.hospDoc==undefined?'':this.editObj.hospDoc;

                }else {
                    let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                    this.docType = '';
                    this.docCode = '';
                    this.docImage = '';
                    this.hospDoc = '';
                    this.zone = zone;
                    let  img = document.getElementById('image1');
                    img.setAttribute('src', '');
                }

            },
            // hospDoc(val){
            //     let show = document.getElementById('ORIJsonCode');
            //     show.innerHTML = val;
            // }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 醫院及科別簡介' : '編輯 醫院及科別簡介'
            },
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            deleteImgIcon(){
                let  img = document.getElementById('image1');
                img.setAttribute('src', '');
            } ,
            pickImage(){
                let inputEl = document.getElementById('iptImage1');
                let imgEl = document.getElementById('image1');
                if (inputEl.files && inputEl.files[0]) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        imgEl.setAttribute('src', e.target.result);
                    };
                    reader.readAsDataURL(inputEl.files[0]);
                }
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                let  img = document.getElementById('image1');
                let imgsrc = img.getAttribute('src');

                if(this.docType==''||this.docCode==''){
                    alert('請輸入簡介類別 和 科別代號')
                }else {
                    this.modifyObj = {
                        zone: this.zone,
                        docImage : imgsrc,
                        docType : this.docType,
                        docCode : this.docCode,
                        hospDoc : this.hospDoc,

                    }
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }

    .custom-file-input {
        color: transparent;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 36px;
        /*min-height: 30px;*/
        /*max-height: 30px;*/
        vertical-align: middle;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        letter-spacing: 0.1em;
        content: '+影像';
        color: black;
        display: inline-block;
        background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
        border: 1px solid #999;
        border-radius: 15px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-shadow: 1px 1px #fff;
        font-weight: 700;
        /*font-size: 10pt;*/
    }
    .custom-file-input:hover::before {
        border-color: black;
    }
    .custom-file-input:active {
        outline: 0;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }

</style>